// deps
import React from "react";

// dls
import { Loader } from "@swiggy-private/dls-web-core/dist/components/Loader";
import { ILoaderSize } from "@swiggy-private/dls-web-core/dist/components/Loader/types";

export interface CircleLoaderProps {
    show?: boolean;
    className?: string;
    "data-testid"?: string;
    size?: ILoaderSize;
}

function CircleLoader(props: CircleLoaderProps): React.ReactElement | null {
    const { show = true, className, size = "medium" } = props;

    if (!show) {
        return null;
    }

    return (
        <div className={className} data-testid={props["data-testid"]}>
            <Loader size={size} type="primary" foregroundColor="primary" backgroundColor="primary_Sub" />
        </div>
    );
}

export default React.memo(CircleLoader);
